// Styles
import styles from './index.module.sass';

// Images
import LOGO from '../../images/sign/logo.png';

export default function OrderHeader() {
  return (
    <div className={styles.orderTopHeader}>
      <div className={styles.logo}>
        <img src={LOGO} alt='logo' />
      </div>
    </div>
  );
}
